var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ButtonContent, ButtonWrapper, FilledButton, Item, Label } from './styles';
import { Input } from '@brg/input';
import { BUTTON_TYPE, UPRISE_TYPE } from './const';
import useLocalization from '../../../../../hooks/useLocalization';
import { Dropdown, DropdownListItem } from '@brg/ui';
import { RectangularButtonFilled } from '../../../../buttons';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { Lang } from '@brg/api';
import { createPortal } from "react-dom";
var LangObj = [{ lang: 'En', name: '' }, { lang: 'Ru', name: '' }];
export var setTextByLang = function (current, lang, value) {
    var _a, _b;
    var engValue = (_a = current.find(function (_a) {
        var lang = _a.lang;
        return lang === 'en';
    })) !== null && _a !== void 0 ? _a : {
        lang: 'en',
        name: '',
    };
    var ruValue = (_b = current.find(function (_a) {
        var lang = _a.lang;
        return lang === 'ru';
    })) !== null && _b !== void 0 ? _b : {
        lang: 'ru',
        name: '',
    };
    if (lang === 'ru') {
        return [{
                lang: 'ru',
                name: value,
            }, engValue];
    }
    else {
        return [ruValue, {
                lang: 'en',
                name: value,
            }];
    }
};
export var LINK_BUTTON_TYPE = 0;
export var ANCHOR_BUTTON_TYPE = 1;
export var BUTTON_OPTIONS = [
    { label: 'контурная', value: 0 },
    { label: 'заполненная', value: 1 },
];
var ButtonAnchor = function (_a) {
    var hasAnchor = _a.hasAnchor, uprise = _a.uprise, handleButtonChange = _a.handleButtonChange, values = _a.values, setDropdownOpen = _a.setDropdownOpen;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var title = values[0], link = values[1], id = values[2], anchors = values[3];
    var currentAnchor = useMemo(function () { return ({ label: link || 'Выберите из списка', value: link, id: id }); }, [link, title, id, language]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_link_text')),
            React.createElement(Input.Text, { maxLength: 20, placeholder: t('editor.buttonBlock.placeholder.button_link_text'), value: Lang(title, language), onChange: function (ev) { return handleButtonChange(setTextByLang(title, language, ev.target.value), false, ev); }, name: 'title' })),
        hasAnchor ? (React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_anchor')),
            React.createElement(Input.Dropdown, { options: anchors, value: currentAnchor, onChange: function (value) { return handleButtonChange(value, true); }, name: 'link', onMenuOpen: function () { return setDropdownOpen && setDropdownOpen(true); }, onMenuClose: function () { return setDropdownOpen && setDropdownOpen(false); } }))) : (React.createElement(Label, { wrap: true }, t('editor.buttonBlock.empty_anchor_msg')))));
};
var ButtonLink = function (_a) {
    var uprise = _a.uprise, handleButtonChange = _a.handleButtonChange, values = _a.values, buttonStyle = _a.buttonStyle;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var title = values[0], link = values[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_link_style')),
            React.createElement(Input.Dropdown, { value: buttonStyle, onChange: function (value) { return handleButtonChange(value, true, { target: { name: 'buttonStyle' } }); }, options: BUTTON_OPTIONS })),
        React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_link_text')),
            React.createElement(Input.Text, { maxLength: 20, onChange: function (ev) { return handleButtonChange(setTextByLang(title, language, ev.target.value), false, ev); }, value: Lang(title, language), placeholder: t('editor.buttonBlock.placeholder.button_link_text'), name: 'title' })),
        React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_link_link')),
            React.createElement(Input.Text, { onChange: function (ev) { return handleButtonChange(ev.target.value, false, ev); }, value: link, placeholder: t('editor.buttonBlock.placeholder.button_link_link'), name: 'link' }))));
};
export var Button = function (_a) {
    var data = _a.data, type = _a.type, uprise = _a.uprise, onAddNewButton = _a.onAddNewButton, isView = _a.isView, isEdited = _a.isEdited, fontColor = _a.fontColor, setDropdownOpen = _a.setDropdownOpen;
    var _b = useState(LangObj), title = _b[0], setTitle = _b[1];
    var _c = useState(''), link = _c[0], setLink = _c[1];
    var _d = useState(''), anchorRoute = _d[0], setAnchorRoute = _d[1];
    var _e = useState(''), id = _e[0], setId = _e[1];
    var anchors = useCommonProps().anchors;
    var _f = useLocalization(), t = _f.t, language = _f.language;
    var _g = useState(BUTTON_OPTIONS[0]), buttonStyle = _g[0], setButtonStyle = _g[1];
    var anchorList = useMemo(function () { return ((anchors && (anchors === null || anchors === void 0 ? void 0 : anchors.map(function (a) { return ({ value: a === null || a === void 0 ? void 0 : a.anchorText, id: a === null || a === void 0 ? void 0 : a.postId }); }))) || []); }, [anchors]);
    var computeType = useMemo(function () { return type === BUTTON_TYPE['button-link'] ? LINK_BUTTON_TYPE : ANCHOR_BUTTON_TYPE; }, [type, data]);
    var anchorOptions = useMemo(function () {
        if (!!(anchorList === null || anchorList === void 0 ? void 0 : anchorList.length)) {
            return anchorList === null || anchorList === void 0 ? void 0 : anchorList.reduce(function (acc, val) {
                var value = val.value, id = val.id;
                return (__spreadArray(__spreadArray([], acc, true), [
                    {
                        label: value,
                        value: value,
                        id: id
                    }
                ], false));
            }, []);
        }
        return [];
    }, []);
    var hasAnchors = useMemo(function () { return (anchorOptions === null || anchorOptions === void 0 ? void 0 : anchorOptions.length); }, [anchorOptions]);
    var handleButtonChange = useCallback(function (val, isSelect, ev) {
        if (isSelect) {
            if (ev && ev.target && ev.target.name === 'buttonStyle') {
                setButtonStyle(val);
                return;
            }
            if (typeof val === 'object' && val.value !== undefined && val.id !== undefined) {
                setAnchorRoute(val.value);
                setId(val.id);
                return;
            }
        }
        if (ev && ev.target) {
            var name_1 = ev.target.name;
            if (name_1 === 'title') {
                setTitle(val);
            }
            else {
                setLink(val);
            }
        }
    }, [title, link]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!!(data === null || data === void 0 ? void 0 : data.length)) {
            var currentType = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.type;
            setTitle((_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.title);
            setId(((_c = data === null || data === void 0 ? void 0 : data[0]) === null || _c === void 0 ? void 0 : _c.id) || '');
            setButtonStyle(BUTTON_OPTIONS[((_d = data === null || data === void 0 ? void 0 : data[0]) === null || _d === void 0 ? void 0 : _d.uprise) || 0]);
            (currentType === LINK_BUTTON_TYPE)
                ? setLink(((_e = data === null || data === void 0 ? void 0 : data[0]) === null || _e === void 0 ? void 0 : _e.link) || '')
                : setAnchorRoute((_f = data === null || data === void 0 ? void 0 : data[0]) === null || _f === void 0 ? void 0 : _f.link);
        }
    }, [data, type]);
    useEffect(function () {
        if (!!(title === null || title === void 0 ? void 0 : title.length) && (type === BUTTON_TYPE['button-link'] ? !!(link === null || link === void 0 ? void 0 : link.length) : !!(anchorRoute === null || anchorRoute === void 0 ? void 0 : anchorRoute.length)) && !isView) {
            onAddNewButton({
                title: title,
                link: (type === BUTTON_TYPE['button-link']) ? link : anchorRoute,
                id: id,
                type: computeType,
                uprise: buttonStyle.value
            });
        }
    }, [title, link, anchorRoute, computeType, buttonStyle, isView, id, type]);
    var button = useMemo(function () {
        var _a;
        if (isView && data) {
            var button_1 = data === null || data === void 0 ? void 0 : data[0];
            var title_1 = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.title;
            var type_1 = button_1 === null || button_1 === void 0 ? void 0 : button_1.type;
            var link_1 = button_1 === null || button_1 === void 0 ? void 0 : button_1.id;
            var buttonStyle_1 = (button_1 === null || button_1 === void 0 ? void 0 : button_1.uprise) === 1 ? 'filled' : 'hollow';
            var classPostFix = (button_1 === null || button_1 === void 0 ? void 0 : button_1.uprise) === 1 ? UPRISE_TYPE.colored : UPRISE_TYPE.normal;
            var additionalParams = window.location.search;
            var href = type_1 === LINK_BUTTON_TYPE ? ((button_1 === null || button_1 === void 0 ? void 0 : button_1.link) && !button_1.link.startsWith('http') && !button_1.link.startsWith('/') && !button_1.link.startsWith('#') && !button_1.link.startsWith('mailto:') && !button_1.link.startsWith('tel:') ? "https://".concat(button_1.link) : button_1 === null || button_1 === void 0 ? void 0 : button_1.link) : "".concat(window.location.pathname).concat(additionalParams, "#").concat(link_1);
            var target = type_1 === LINK_BUTTON_TYPE ? '_BLANK' : '_SELF';
            return (React.createElement("a", { href: href, target: target },
                React.createElement(FilledButton, { buttonStyle: buttonStyle_1, fontColor: fontColor, className: "button_".concat(uprise), uprise: uprise }, Lang(title_1, language))));
        }
        switch (type) {
            case BUTTON_TYPE['button-link']:
                return React.createElement(ButtonLink, { className: "button_".concat(uprise), uprise: uprise, handleButtonChange: handleButtonChange, values: [title, link], buttonStyle: buttonStyle });
            default:
                return React.createElement(ButtonAnchor, { className: "button_".concat(uprise), uprise: uprise, handleButtonChange: handleButtonChange, values: [title, anchorRoute, id, anchorOptions], hasAnchor: hasAnchors, setDropdownOpen: setDropdownOpen });
        }
    }, [type, isView, data, title, link, anchorList, isView, language, id, buttonStyle, setDropdownOpen]);
    //Вызывает баги. Разобраться почему не работает портал @Artem
    //   if (!isView || !data) {
    //     const outer = document.getElementById('button-anchor__portal');
    //     if (!outer) {
    //       return null;
    //     }
    //     return createPortal(
    //       <ButtonWrapper uprise={uprise} isView={isView} isPortal>
    //         <ButtonContent className={'button-content'} gy={16} gyMobile={16} uprise={uprise}>
    //           {button}
    //         </ButtonContent>
    //       </ButtonWrapper>, outer
    //     );
    //   }
    return (React.createElement(ButtonWrapper, { uprise: uprise, isView: isView, style: { zIndex: 10000000 } },
        React.createElement(ButtonContent, { className: 'button-content', gy: 16, gyMobile: 16, uprise: uprise }, button)));
};
//# sourceMappingURL=Button.js.mapvar __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ButtonContent, ButtonWrapper, FilledButton, Item, Label } from './styles';
import { Input } from '@brg/input';
import { BUTTON_TYPE, UPRISE_TYPE } from './const';
import useLocalization from '../../../../../hooks/useLocalization';
import { Dropdown, DropdownListItem } from '@brg/ui';
import { RectangularButtonFilled } from '../../../../buttons';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { Lang } from '@brg/api';
import { createPortal } from "react-dom";
var LangObj = [{ lang: 'En', name: '' }, { lang: 'Ru', name: '' }];
export var setTextByLang = function (current, lang, value) {
    var _a, _b;
    var engValue = (_a = current.find(function (_a) {
        var lang = _a.lang;
        return lang === 'en';
    })) !== null && _a !== void 0 ? _a : {
        lang: 'en',
        name: '',
    };
    var ruValue = (_b = current.find(function (_a) {
        var lang = _a.lang;
        return lang === 'ru';
    })) !== null && _b !== void 0 ? _b : {
        lang: 'ru',
        name: '',
    };
    if (lang === 'ru') {
        return [{
                lang: 'ru',
                name: value,
            }, engValue];
    }
    else {
        return [ruValue, {
                lang: 'en',
                name: value,
            }];
    }
};
export var LINK_BUTTON_TYPE = 0;
export var ANCHOR_BUTTON_TYPE = 1;
export var BUTTON_OPTIONS = [
    { label: 'контурная', value: 0 },
    { label: 'заполненная', value: 1 },
];
var ButtonAnchor = function (_a) {
    var hasAnchor = _a.hasAnchor, uprise = _a.uprise, handleButtonChange = _a.handleButtonChange, values = _a.values, setDropdownOpen = _a.setDropdownOpen;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var title = values[0], link = values[1], id = values[2], anchors = values[3];
    var currentAnchor = useMemo(function () { return ({ label: link || 'Выберите из списка', value: link, id: id }); }, [link, title, id, language]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_link_text')),
            React.createElement(Input.Text, { maxLength: 20, placeholder: t('editor.buttonBlock.placeholder.button_link_text'), value: Lang(title, language), onChange: function (ev) { return handleButtonChange(setTextByLang(title, language, ev.target.value), false, ev); }, name: 'title' })),
        hasAnchor ? (React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_anchor')),
            React.createElement(Input.Dropdown, { options: anchors, value: currentAnchor, onChange: function (value) { return handleButtonChange(value, true); }, name: 'link', onMenuOpen: function () { return setDropdownOpen && setDropdownOpen(true); }, onMenuClose: function () { return setDropdownOpen && setDropdownOpen(false); } }))) : (React.createElement(Label, { wrap: true }, t('editor.buttonBlock.empty_anchor_msg')))));
};
var ButtonLink = function (_a) {
    var uprise = _a.uprise, handleButtonChange = _a.handleButtonChange, values = _a.values, buttonStyle = _a.buttonStyle;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var title = values[0], link = values[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_link_style')),
            React.createElement(Input.Dropdown, { value: buttonStyle, onChange: function (value) { return handleButtonChange(value, true, { target: { name: 'buttonStyle' } }); }, options: BUTTON_OPTIONS })),
        React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_link_text')),
            React.createElement(Input.Text, { maxLength: 20, onChange: function (ev) { return handleButtonChange(setTextByLang(title, language, ev.target.value), false, ev); }, value: Lang(title, language), placeholder: t('editor.buttonBlock.placeholder.button_link_text'), name: 'title' })),
        React.createElement(Item, { gx: 24, gxMobile: 24 },
            React.createElement(Label, null, t('editor.buttonBlock.button_link_link')),
            React.createElement(Input.Text, { onChange: function (ev) { return handleButtonChange(ev.target.value, false, ev); }, value: link, placeholder: t('editor.buttonBlock.placeholder.button_link_link'), name: 'link' }))));
};
export var Button = function (_a) {
    var data = _a.data, type = _a.type, uprise = _a.uprise, onAddNewButton = _a.onAddNewButton, isView = _a.isView, isEdited = _a.isEdited, fontColor = _a.fontColor, setDropdownOpen = _a.setDropdownOpen;
    var _b = useState(LangObj), title = _b[0], setTitle = _b[1];
    var _c = useState(''), link = _c[0], setLink = _c[1];
    var _d = useState(''), anchorRoute = _d[0], setAnchorRoute = _d[1];
    var _e = useState(''), id = _e[0], setId = _e[1];
    var anchors = useCommonProps().anchors;
    var _f = useLocalization(), t = _f.t, language = _f.language;
    var _g = useState(BUTTON_OPTIONS[0]), buttonStyle = _g[0], setButtonStyle = _g[1];
    var anchorList = useMemo(function () { return ((anchors && (anchors === null || anchors === void 0 ? void 0 : anchors.map(function (a) { return ({ value: a === null || a === void 0 ? void 0 : a.anchorText, id: a === null || a === void 0 ? void 0 : a.postId }); }))) || []); }, [anchors]);
    var computeType = useMemo(function () { return type === BUTTON_TYPE['button-link'] ? LINK_BUTTON_TYPE : ANCHOR_BUTTON_TYPE; }, [type, data]);
    var anchorOptions = useMemo(function () {
        if (!!(anchorList === null || anchorList === void 0 ? void 0 : anchorList.length)) {
            return anchorList === null || anchorList === void 0 ? void 0 : anchorList.reduce(function (acc, val) {
                var value = val.value, id = val.id;
                return (__spreadArray(__spreadArray([], acc, true), [
                    {
                        label: value,
                        value: value,
                        id: id
                    }
                ], false));
            }, []);
        }
        return [];
    }, []);
    var hasAnchors = useMemo(function () { return (anchorOptions === null || anchorOptions === void 0 ? void 0 : anchorOptions.length); }, [anchorOptions]);
    var handleButtonChange = useCallback(function (val, isSelect, ev) {
        if (isSelect) {
            if (ev && ev.target && ev.target.name === 'buttonStyle') {
                setButtonStyle(val);
                return;
            }
            if (typeof val === 'object' && val.value !== undefined && val.id !== undefined) {
                setAnchorRoute(val.value);
                setId(val.id);
                return;
            }
        }
        if (ev && ev.target) {
            var name_1 = ev.target.name;
            if (name_1 === 'title') {
                setTitle(val);
            }
            else {
                setLink(val);
            }
        }
    }, [title, link]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!!(data === null || data === void 0 ? void 0 : data.length)) {
            var currentType = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.type;
            setTitle((_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.title);
            setId(((_c = data === null || data === void 0 ? void 0 : data[0]) === null || _c === void 0 ? void 0 : _c.id) || '');
            setButtonStyle(BUTTON_OPTIONS[((_d = data === null || data === void 0 ? void 0 : data[0]) === null || _d === void 0 ? void 0 : _d.uprise) || 0]);
            (currentType === LINK_BUTTON_TYPE)
                ? setLink(((_e = data === null || data === void 0 ? void 0 : data[0]) === null || _e === void 0 ? void 0 : _e.link) || '')
                : setAnchorRoute((_f = data === null || data === void 0 ? void 0 : data[0]) === null || _f === void 0 ? void 0 : _f.link);
        }
    }, [data, type]);
    useEffect(function () {
        if (!!(title === null || title === void 0 ? void 0 : title.length) && (type === BUTTON_TYPE['button-link'] ? !!(link === null || link === void 0 ? void 0 : link.length) : !!(anchorRoute === null || anchorRoute === void 0 ? void 0 : anchorRoute.length)) && !isView) {
            onAddNewButton({
                title: title,
                link: (type === BUTTON_TYPE['button-link']) ? link : anchorRoute,
                id: id,
                type: computeType,
                uprise: buttonStyle.value
            });
        }
    }, [title, link, anchorRoute, computeType, buttonStyle, isView, id, type]);
    var button = useMemo(function () {
        var _a;
        if (isView && data) {
            var button_1 = data === null || data === void 0 ? void 0 : data[0];
            var title_1 = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.title;
            var type_1 = button_1 === null || button_1 === void 0 ? void 0 : button_1.type;
            var link_1 = button_1 === null || button_1 === void 0 ? void 0 : button_1.id;
            var buttonStyle_1 = (button_1 === null || button_1 === void 0 ? void 0 : button_1.uprise) === 1 ? 'filled' : 'hollow';
            var classPostFix = (button_1 === null || button_1 === void 0 ? void 0 : button_1.uprise) === 1 ? UPRISE_TYPE.colored : UPRISE_TYPE.normal;
            var additionalParams = window.location.search;
            var href = type_1 === LINK_BUTTON_TYPE ? ((button_1 === null || button_1 === void 0 ? void 0 : button_1.link) && !button_1.link.startsWith('http') && !button_1.link.startsWith('/') && !button_1.link.startsWith('#') && !button_1.link.startsWith('mailto:') && !button_1.link.startsWith('tel:') ? "https://".concat(button_1.link) : button_1 === null || button_1 === void 0 ? void 0 : button_1.link) : "".concat(window.location.pathname).concat(additionalParams, "#").concat(link_1);
            var target = type_1 === LINK_BUTTON_TYPE ? '_BLANK' : '_SELF';
            return (React.createElement("a", { href: href, target: target },
                React.createElement(FilledButton, { buttonStyle: buttonStyle_1, fontColor: fontColor, className: "button_".concat(uprise), uprise: uprise }, Lang(title_1, language))));
        }
        switch (type) {
            case BUTTON_TYPE['button-link']:
                return React.createElement(ButtonLink, { className: "button_".concat(uprise), uprise: uprise, handleButtonChange: handleButtonChange, values: [title, link], buttonStyle: buttonStyle });
            default:
                return React.createElement(ButtonAnchor, { className: "button_".concat(uprise), uprise: uprise, handleButtonChange: handleButtonChange, values: [title, anchorRoute, id, anchorOptions], hasAnchor: hasAnchors, setDropdownOpen: setDropdownOpen });
        }
    }, [type, isView, data, title, link, anchorList, isView, language, id, buttonStyle, setDropdownOpen]);
    //Вызывает баги. Разобраться почему не работает портал @Artem
    //   if (!isView || !data) {
    //     const outer = document.getElementById('button-anchor__portal');
    //     if (!outer) {
    //       return null;
    //     }
    //     return createPortal(
    //       <ButtonWrapper uprise={uprise} isView={isView} isPortal>
    //         <ButtonContent className={'button-content'} gy={16} gyMobile={16} uprise={uprise}>
    //           {button}
    //         </ButtonContent>
    //       </ButtonWrapper>, outer
    //     );
    //   }
    return (React.createElement(ButtonWrapper, { uprise: uprise, isView: isView, style: { zIndex: 10000000 } },
        React.createElement(ButtonContent, { className: 'button-content', gy: 16, gyMobile: 16, uprise: uprise }, button)));
};
//# sourceMappingURL=Button.js.map